import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { concatMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { ListCategories } from '../action-creators';
import { LoginUserSuccess } from '@webapp/store/auth/action-creators';
import { LOGIN_USER_SUCCESS } from '@webapp/store/auth/actions';
import { GetAchievements } from '@webapp/store/artist/action-creators';

export const loadAfterLoginEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, LoginUserSuccess>(LOGIN_USER_SUCCESS),
    concatMap(() => [
      new ListCategories('genre'),
      new ListCategories('platform'),
      new ListCategories('region'),
      new ListCategories('language'),
      new GetAchievements(),
    ])
  );
